import * as React from 'react'
import './Token.css'

import * as Model from '../types/document'
import { Cursor } from 'src/lib/Cursor';
import { HoveredNodeConsumer, HoveredNodeContext } from 'src/view/HoveredNodeContext';
import { NetworkUser } from 'golgi';
import { withContext, Prop } from 'src/view/withContext';
import * as actions from '../actions'
import { Stack } from 'src/types/stack';

export interface TokenProps extends React.HTMLProps<HTMLSpanElement> {
  children?: React.ReactNode,
  className?: string,
  nodeId?: Model.NodeId,
  stack?: Stack,
  dumb?: boolean,
}

class Token extends React.Component<TokenProps & Prop<'hoveredNode', HoveredNodeContext>> {
  render() {
    const {children, className = "", nodeId, stack, hoveredNode, dumb, ...spanProps} = this.props

    // it's called "dumb" for more than one reason
    if (dumb) {
      return <span className={"Token " + className} {...spanProps}>
        {children}
      </span>
    }

    return <NetworkUser debugName="Token" props={this.props} state={this.state} render={() => {
      return <span
          className={"Token " + className} 
          style={
            nodeId && stack && hoveredNode.is && hoveredNode.is(nodeId, stack)
            ? {backgroundImage: "linear-gradient(to bottom, #BFF2E6, #66E0C2)"}
            : {}
          }
          onMouseOver={() => actions.act(() =>
            nodeId && stack && hoveredNode.set && hoveredNode.set(nodeId, stack)
          )}
          onMouseOut={() => actions.act(() =>
            nodeId && stack && hoveredNode.clear && hoveredNode.clear()
          )}
          {...spanProps}>
        {children}
      </span>
    }} />
  }
}

export default withContext<HoveredNodeContext, 'hoveredNode', TokenProps>('hoveredNode', HoveredNodeConsumer)(Token);



// WEBPACK FOOTER //
// ./src/view/Token.tsx